import { http } from 'interfaces'
import { type Address, type PersonPhone, type PositionType } from 'services'
import { type PositionsFilter } from 'pages'
export interface Person {
  id?: number
  uniqueId?: string
  prefixId?: number
  prefixLocal?: string
  firstName: string
  firstNameLocal?: string
  middleName?: string
  middleNameLocal?: string
  lastName: string
  lastNameLocal?: string
  suffixId?: number
  suffixLocal?: string
  profSuffix?: string
  profSuffixLocal?: string
  legalName?: string
  legalNameLocal?: string
  nickname?: string
  nicknameLocal?: string
  pronunciation?: string
  pronunciationLocal?: string
  ethnicId?: number
  genderId?: number
  maritalStatusId?: number
  partyId?: number
  religionId?: number
  birthplace?: string
  birthYear?: number
  birthMonth?: number
  deathYear?: number
  residence?: string
  familyLocal?: string
  lastUpdated?: string
}

export interface PersonAddress {
  id?: number
  personId?: number
  primaryAddress: Address
  secondaryAddress: Address
  phone?: PersonPhone | null
  displayOrder?: number | null
}
interface organizationType {
  id: number
  typeCode: string
}

export interface PositionOrganization {
  uniqueId?: string
  id: number
  type?: organizationType
  organizationName?: string
  topLevelOrg?: PositionOrganization
}

export interface PositionBase {
  id: number
  person?: Person
  regionId?: number | null
  countryId?: number | null
  typeId: number | null
  title: string
  titleLocal: string
  displayOrder: number
  updatedBy?: string
  lastUpdated?: string
  commentLastUpdated?: string | null
  address: PersonAddress | null
}

export interface Position extends PositionBase {
  organization: PositionOrganization
}

export interface PositionFilterResults {
  data: Position[]
  page_number: number
  page_size: number
  total_pages: number
  total_items: number
}

export async function positionListOrg (orgId: number, pageNumber: number = 1, pageSize: number = 100, filters: PositionsFilter): Promise<PositionFilterResults> {
  const positionTypeIds: number[] = filters.positionTypes.map((positionType: PositionType) => positionType.id)

  const nonEmptyFilters = {
    ...Object.fromEntries(Object.entries(filters).filter(([key, value]) => value !== '' && key !== 'positionTypes')),
    vacant: filters.vacant === 'vacant' ? true : filters.vacant === 'Occupied' ? false : undefined,
    positionTypeIds
  }
  return await http.get(`/api/v1/organizations/${orgId}/positions/`, {
    params: { page: pageNumber, page_size: pageSize, ...nonEmptyFilters }
  }).then(value => value.data)
    .catch(reason => {
      const resultEmpty: PositionFilterResults = {
        page_number: 0,
        page_size: 0,
        total_items: 0,
        total_pages: 0,
        data: []
      }
      return resultEmpty
    })
}
